import {MUTATION_KEYS} from '@/queryClient.ts'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types'
import {httpResetPassword} from './auth.http'

type UseResetPasswordOptions = {
    onSuccess?: () => void
    onError?: (error: AxiosError<ErrorResponseData>) => void
}

export const useResetPassword = (options?: UseResetPasswordOptions) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.RESET_PASSWORD],
        mutationFn: httpResetPassword,
        onError: (error: AxiosError<ErrorResponseData>) => options?.onError?.(error),
        onSuccess: () => options?.onSuccess?.()
    })
